import React__default, { Component } from 'react';
import { sentryHandler } from '@sravni/ugc/lib/utils/sentry/sentryHandler';

class Interceptor extends Component {
    state = {
        error: null,
    };
    componentDidCatch(error, errorInfo) {
        const { componentName, isProduction } = this.props;
        if (isProduction) {
            sentryHandler(error, { extra: { error, errorInfo, componentName }, tag: `${componentName}-interceptor` });
            this.setState({
                error: error,
            });
        }
    }
    render() {
        if (this.state.error) {
            return (React__default.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', flex: '1 1 100%' } },
                React__default.createElement("h1", null, "\u0423\u043F\u0441, \u0443 \u043D\u0430\u0441 \u0447\u0442\u043E-\u0442\u043E \u0441\u043B\u043E\u043C\u0430\u043B\u043E\u0441\u044C... =(")));
        }
        return this.props.children;
    }
}

export { Interceptor };
//# sourceMappingURL=Interceptor.js.map
